/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {approvePlatformClient} from '../api'

export const useMutationApprovePlatformClient = createReactQueryMutationHook('approvePlatformClient', approvePlatformClient)
